import { inject, Injectable } from '@angular/core';
import { TranslateOrDefault } from '@language';
import { TranslateService } from '@ngx-translate/core';
import { DottedKey } from '../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { RecordStatus } from '../../../../core/records/entities/metadata/metadata.entity';
import { LabelType } from '../../../../elements/components/label/entities/label-type.entity';
import { StatusMapper } from '../../../helpers/status-mapper.helper';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { StatusCell } from '../../components/cells/status-cell/status-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class RecordStatusColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.SMALL;
    protected readonly DISABLE_SORT: boolean = false;
    private readonly translateService: TranslateService = inject(TranslateService);

    protected getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return record => {
            const type: LabelType = StatusMapper.getRecordStatusLabelType(
                record.getRecordStatus(),
                record.hasFailedJobs(),
                record.hasErrors()
            );
            const label: string = this.translateRecordStatus(record.getRecordStatus());
            return new StatusCell(label, type);
        };
    }

    private translateRecordStatus(status: RecordStatus): string {
        return TranslateOrDefault(this.translateService, `overrides.RecordStatus.${status}`, status);
    }

    protected getFieldSelectDottedKeys(profileField: ExtendedProfileField): DottedKey[] {
        return ['Administrative.RecordStatus', 'Administrative.HasFailedJobs'] as DottedKey[];
    }
}
